import { TransformsList, Data } from 'cio/utils/analytics/transforms';
import { generateSource } from 'cio/utils/analytics/sources';

function generateBaseData(data: Data) {
  return {
    Source: data.source ?? generateSource(data),
    'Is Resend': data.isResend ? 'Yes' : 'No',
  };
}

function generateAttributes(eventData: string) {
  let attributes: string[] = [];

  try {
    attributes = Object.keys(JSON.parse(eventData));
  } catch {}

  return attributes;
}

const Transforms: TransformsList = {
  sendStarted(data) {
    return generateBaseData(data);
  },

  sendCompleted(data) {
    let attributes = generateAttributes(data.eventData);

    return {
      ...generateBaseData(data),
      'Event Name': data.eventName,
      'Event Attribute Payload': attributes,
      'Event Attribute Count': attributes.length,
      'Event Attribute Editor Type': data.editorType,
    };
  },

  errorEncountered(data) {
    let attributes = generateAttributes(data.eventData);

    return {
      ...generateBaseData(data),
      'Error Message': data.message,
      'Event Name': data.eventName,
      'Event Attribute Payload': attributes,
      'Event Attribute Count': attributes.length,
      'Event Attribute Editor Type': data.editorType,
    };
  },
};

export default Transforms;
